var file_upload_viewer_default = {
  "fontElementMap": "IfHev",
  "file_upload_container": "_59gxg",
  "file_upload_link": "_7nrfG",
  "file_upload_error_container": "lLWKI",
  "file_upload_file_info": "_9-GMI",
  "file_upload_type_icon": "ZjQtu",
  "file_upload_status_icon_container": "a554P",
  "file_upload_status_icon": "_-3rF7",
  "file_upload_description": "r0-ZM",
  "file_upload_name_container": "_46si9",
  "file_upload_name": "HZXOs",
  "file_upload_extension": "xGK9C",
  "file_loader_icon": "t5QVh",
  "file_upload_icon_frame": "fv8Ds",
  "file_upload_icon_background": "QnqqQ"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
